import { useApiQuery } from '@locus-taxy/encore-ui-network';
import { useToast } from '@locus-taxy/encore-ui-toolkit';
import type { ApiError } from '@locus-taxy/encore-ui-network';

export interface DocumentInfo {
  fileId: string;
  fileName?: string;
  fileType?: string;
  contentType?: string;
  storageMetadata?: {
    url?: string;
    bucketName?: string;
    key?: string;
    provider?: 'S3' | 'EXTERNAL';
  };
}

export interface ProfileInformation {
  photo?: DocumentInfo;
  phoneNumber?: string;
  emailAddress?: string;
  dateOfBirth?: string;
  gender?: string;
}

export interface UserPreferences {
  localeIdentifier: string;
  timezone: string;
}

export interface PersonnelEntityData {
  id: string;
  name: string;
  roleId?: string;
  status: string;
  profileInformation?: ProfileInformation;
  teamIds: string[];
  skillIds?: string[];
  preferences?: UserPreferences;
  localeSettings?: Record<string, unknown>;
}

export interface MeResponse {
  data: {
    id: string;
    entityData: PersonnelEntityData;
    schemaInfo: {
      schemaVersion: string;
    };
    metadata: {
      processInstanceKey: string;
      rootInstanceKey: string;
    };
    createdAt: string;
    updatedAt: string;
    createdBy: string;
    updatedBy: string;
    deleted: boolean;
  };
  success: boolean;
}

export function useCurrentUser(clientId: string) {
  const { showApiError } = useToast();
  return useApiQuery<MeResponse>({
    key: ['me', clientId],
    endpointKey: 'me.get',
    params: { clientId },
    config: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      onError: (error: ApiError) => {
        showApiError(error);
      },
    },
  });
}
